import { render, staticRenderFns } from "./CuentaCorriente.vue?vue&type=template&id=685ec4c0&"
import script from "./CuentaCorriente.vue?vue&type=script&lang=js&"
export * from "./CuentaCorriente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports